import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

interface EmptyStateProps {
  title?: string;
  description: string;
  action?: ReactNode;
  className?: string;
}

export default function EmptyState({
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'text-muted-foreground flex flex-col items-start gap-2 py-6 text-sm',
        className
      )}
    >
      {title ? <p className="text-foreground font-medium">{title}</p> : null}
      <p>{description}</p>
      {action}
    </div>
  );
}
